import React from "react";
import { useNavigate } from "react-router-dom";
import avatarImg from "../assets/avatar.jpg"; // Importa la imagen

const Header = ({ toggleSidebar, onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout();
    navigate("/login");
  };

  return (
    <div className="p-4 border-b border-gray-800 flex justify-between items-center gap-4 bg-gray-900">
      <button
        className="md:hidden p-2 text-gray-300 bg-gray-800/50 rounded"
        onClick={toggleSidebar}
      >
        <span className="material-symbols-outlined">menu</span>
      </button>

      <div className="flex items-center gap-3 ml-auto">
        <div
          className="w-10 h-10 rounded-full bg-cover bg-center"
          style={{ backgroundImage: `url(${avatarImg})` }}
        />
        <div>
          <p className="font-semibold text-white">Admin User</p>
          <button
            onClick={handleLogout}
            className="text-sm text-gray-400 hover:text-primary-400"
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
